import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className,
  id,
  delay = 0
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut',
    delay
  }} className={clsx('py-16 md:py-24 px-6 md:px-8 max-w-4xl mx-auto', className)} data-id="element-204">
      {children}
    </motion.section>;
}